import { getQaSelector } from '../../../../../../utils/common'

import {
  LISTING_PROFILE_AVAILABLE_FROM_ACTION_KEY_DELETE,
  QA_NAME_LISTING_PROFILE_AVAILABLE_FROM_CELL,
} from './ListingProfileAvailableFromItem.constants'

export function getListingProfileAvailableFromContentWrapperProps({
  canEdit,
  onClick,
}) {
  return canEdit
    ? {
        ...getQaSelector({
          value: QA_NAME_LISTING_PROFILE_AVAILABLE_FROM_CELL,
        }),
        onClick,
      }
    : null
}

export function getListingProfileAvailableFromHandlers(onClickDelete) {
  return {
    [LISTING_PROFILE_AVAILABLE_FROM_ACTION_KEY_DELETE]: {
      onClick: onClickDelete,
    },
  }
}
